import { useIsFetching } from "@tanstack/react-query";

import { savedSearchFiltersQueryKeys } from "app/pages/sales-intelligence/modules/leads-search/sub-modules/saved-search/query";
import { leadsSearchFiltersQueryKeys } from "app/pages/sales-intelligence/modules/leads-search-filters";
import { technologyQueryKeys } from "app/pages/sales-intelligence/modules/technology/queries/queryKeyFactory";

export const useIsLeadsCriticalDataLoading = () => {
    const filtersDescriptionFetchingCount = useIsFetching({ queryKey: leadsSearchFiltersQueryKeys.description() });
    const technologyFetchingCount = useIsFetching({ queryKey: technologyQueryKeys.description() });
    const savedSearchByIdFetchingCount = useIsFetching({ queryKey: savedSearchFiltersQueryKeys.getById() });

    const loadingConditions: boolean[] = [
        filtersDescriptionFetchingCount > 0,
        savedSearchByIdFetchingCount > 0,
        technologyFetchingCount > 0,
    ];

    return loadingConditions.some(Boolean);
};
